import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer } from 'preact-i18n';

import localUtil from '../../lib/util';
import Comments from '../../components/comments';

@observer
class LotTestingViewOnly extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        const { id } = this.props;
        if (id) {
            this.loadLotTesting(id);
        }
    }

    loadLotTesting = async (id) => {
        const { lotTestingStore } = this.props.stores;
        await lotTestingStore.loadWithComments(id);
    }

    editLotTesting = () => {
        const { appState, lotTestingStore } = this.props.stores;
        const { drawerHeightMediumLarge } = appState;
        const { lotTesting } = lotTestingStore;

        appState.openDrawer('editLotTesting', {
            height: drawerHeightMediumLarge,
            id: lotTesting.id,
            callback: () => {
                lotTestingStore.load({});
            },
        }, 2);
    }

    addWeaponTest = () => {
        const { drawerLevel = 1 } = this.props;
        const { appState, lotTestingStore } = this.props.stores;
        const { drawerHeightMedium } = appState;
        const { lotTesting } = lotTestingStore;

        appState.openDrawer('addWeaponTest', {
            height: drawerHeightMedium,
            lotTestingId: lotTesting.id,
            isNew: true,
            callback: () => lotTestingStore.loadWithComments(lotTesting.id),
        }, drawerLevel + 1);
    }

    editWeaponTest = (test) => {
        const { drawerLevel = 1 } = this.props;
        const { appState, lotTestingStore } = this.props.stores;
        const { drawerHeightMedium } = appState;
        const { lotTesting } = lotTestingStore;

        appState.openDrawer('editWeaponTest', {
            height: drawerHeightMedium,
            lotTestingId: lotTesting.id,
            testUuidv4: test.uuidv4,
            isNew: false,
            callback: () => lotTestingStore.loadWithComments(lotTesting.id),
        }, drawerLevel + 1);
    }

    render() {
        const { lotTestingStore, userStore } = this.props.stores;
        const { lotTesting = {} } = lotTestingStore;
        const { user = {}, isAdmin } = userStore;
        const darkmode = util.getNestedValue(user, 'settings.darkmode');

        const weaponTests = lotTesting.weaponTests || [];
        const images = lotTesting.images || [];
        const canEdit = isAdmin || lotTesting.user === user.id;

        return (
            <div class='lot-testing-view-only'>
                <div class='w-100 d-flex justify-content-center'>
                    <div class='w-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 100px;'>

                        {/* Header */}
                        <div class='d-flex justify-content-between align-items-center px-3 mb-3'>
                            <div>
                                <h4 class='mb-1'>
                                    <i class='fa-solid fa-flask me-2' />
                                    {lotTesting.lotNumber || 'LOT Testing Entry'}
                                </h4>
                                <div class='text-muted small'>
                                    {lotTesting.brand} {lotTesting.caliber}
                                    {lotTesting.isPublic && (
                                        <span class='ms-2 badge bg-success'>
                                            <i class='fa-solid fa-globe me-1' />
                                            Public
                                        </span>
                                    )}
                                </div>
                            </div>
                            {canEdit && (
                                <button
                                    type='button'
                                    class='btn btn-outline-primary rounded-pill'
                                    onClick={this.editLotTesting}
                                >
                                    <i class='fa-solid fa-pen me-1' />
                                    Edit
                                </button>
                            )}
                        </div>

                        {/* Images */}
                        {images.length > 0 && (
                            <div class='px-3 mb-4'>
                                <div class='d-flex flex-wrap gap-2'>
                                    {images.map((img, idx) => (
                                        <img
                                            key={idx}
                                            src={img.s3MediumLink || img.s3Link}
                                            alt={`LOT image ${idx + 1}`}
                                            class='rounded'
                                            style='max-height: 150px; object-fit: cover;'
                                        />
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* LOT Info Card */}
                        <div class='px-3 mb-4'>
                            <div class='card'>
                                <div class='card-header'>
                                    <i class='fa-solid fa-info-circle me-2' />
                                    LOT Information
                                </div>
                                <div class='card-body'>
                                    <div class='row g-3'>
                                        <div class='col-md-4'>
                                            <div class='text-muted small'>LOT Number</div>
                                            <div class='fw-bold'>{lotTesting.lotNumber || '-'}</div>
                                        </div>
                                        <div class='col-md-4'>
                                            <div class='text-muted small'>Brand</div>
                                            <div class='fw-bold'>{lotTesting.brand || '-'}</div>
                                        </div>
                                        <div class='col-md-4'>
                                            <div class='text-muted small'>Caliber</div>
                                            <div class='fw-bold'>{lotTesting.caliber || '-'}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Ammunition Components Card */}
                        {!!(lotTesting.casing || lotTesting.primer || lotTesting.powder || lotTesting.powderCharge) && (
                            <div class='px-3 mb-4'>
                                <div class='card'>
                                    <div class='card-header'>
                                        <i class='fa-solid fa-capsules me-2' />
                                        Ammunition Components
                                    </div>
                                    <div class='card-body'>
                                        <div class='row g-3'>
                                            {lotTesting.casing && (
                                                <div class='col-md-3'>
                                                    <div class='text-muted small'>Casing</div>
                                                    <div>{lotTesting.casing}</div>
                                                </div>
                                            )}
                                            {lotTesting.primer && (
                                                <div class='col-md-3'>
                                                    <div class='text-muted small'>Primer</div>
                                                    <div>{lotTesting.primer}</div>
                                                </div>
                                            )}
                                            {lotTesting.powder && (
                                                <div class='col-md-3'>
                                                    <div class='text-muted small'>Powder</div>
                                                    <div>{lotTesting.powder}</div>
                                                </div>
                                            )}
                                            {lotTesting.powderCharge && (
                                                <div class='col-md-3'>
                                                    <div class='text-muted small'>Powder Charge</div>
                                                    <div>{lotTesting.powderCharge} gr</div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Bullet Details Card */}
                        {!!(lotTesting.bulletBrand || lotTesting.bulletType || lotTesting.bulletWeight || lotTesting.oal) && (
                            <div class='px-3 mb-4'>
                                <div class='card'>
                                    <div class='card-header'>
                                        <i class='fa-solid fa-shapes me-2' />
                                        Bullet Details
                                    </div>
                                    <div class='card-body'>
                                        <div class='row g-3'>
                                            {lotTesting.bulletBrand && (
                                                <div class='col-md-3'>
                                                    <div class='text-muted small'>Brand</div>
                                                    <div>{lotTesting.bulletBrand}</div>
                                                </div>
                                            )}
                                            {lotTesting.bulletType && (
                                                <div class='col-md-3'>
                                                    <div class='text-muted small'>Type</div>
                                                    <div>{lotTesting.bulletType}</div>
                                                </div>
                                            )}
                                            {lotTesting.bulletWeight && (
                                                <div class='col-md-3'>
                                                    <div class='text-muted small'>Weight</div>
                                                    <div>{lotTesting.bulletWeight} gr</div>
                                                </div>
                                            )}
                                            {lotTesting.oal && (
                                                <div class='col-md-3'>
                                                    <div class='text-muted small'>OAL</div>
                                                    <div>{lotTesting.oal}</div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Notes */}
                        {lotTesting.notes && (
                            <div class='px-3 mb-4'>
                                <div class='card'>
                                    <div class='card-header'>
                                        <i class='fa-solid fa-note-sticky me-2' />
                                        Notes
                                    </div>
                                    <div class='card-body'>
                                        <p class='mb-0' style='white-space: pre-wrap;'>{lotTesting.notes}</p>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Weapon Tests */}
                        <div class='px-3 mb-4'>
                            <div class='card'>
                                <div class='card-header d-flex justify-content-between align-items-center'>
                                    <span>
                                        <i class='fa-solid fa-gun me-2' />
                                        Weapon Tests ({weaponTests.length})
                                    </span>
                                    {canEdit && (
                                        <button
                                            type='button'
                                            class='btn btn-sm btn-outline-primary rounded-pill'
                                            onClick={this.addWeaponTest}
                                        >
                                            <i class='fa-solid fa-plus me-1' />
                                            Add Test
                                        </button>
                                    )}
                                </div>
                                <div class='card-body p-0'>
                                    {weaponTests.length === 0 ? (
                                        <div class='text-center py-4 text-muted'>
                                            <i class='fa-solid fa-gun fa-2x mb-2' />
                                            <p class='mb-0'>No weapon tests recorded yet.</p>
                                            {canEdit && (
                                                <button
                                                    type='button'
                                                    class='btn btn-sm btn-outline-primary rounded-pill mt-2'
                                                    onClick={this.addWeaponTest}
                                                >
                                                    <i class='fa-solid fa-plus me-1' />
                                                    Add your first test
                                                </button>
                                            )}
                                        </div>
                                    ) : (
                                        <div class='list-group list-group-flush'>
                                            {weaponTests.map(test => (
                                                <div
                                                    key={test.uuidv4}
                                                    class={`list-group-item ${canEdit ? 'list-group-item-action' : ''}`}
                                                    style={canEdit ? 'cursor: pointer;' : ''}
                                                    onClick={() => canEdit && this.editWeaponTest(test)}
                                                >
                                                    <div class='d-flex justify-content-between align-items-start'>
                                                        <div class='flex-grow-1'>
                                                            <div class='d-flex justify-content-between'>
                                                                <h6 class='mb-1'>
                                                                    <i class='fa-solid fa-gun me-2 text-muted' />
                                                                    {test.weaponBrand} {test.weaponModel}
                                                                    {test.barrelLength ? ` (${test.barrelLength}")` : ''}
                                                                </h6>
                                                                <small class='text-muted'>
                                                                    {test.testDate ? localUtil.formatDate(test.testDate) : '-'}
                                                                </small>
                                                            </div>

                                                            {/* Test Results */}
                                                            <div class='d-flex flex-wrap gap-2 mt-2'>
                                                                {test.shotCount && (
                                                                    <span class='badge bg-secondary'>
                                                                        <i class='fa-solid fa-hashtag me-1' />
                                                                        {test.shotCount} shots
                                                                    </span>
                                                                )}
                                                                {test.isIndoor && (
                                                                    <span class='badge bg-dark'>
                                                                        <i class='fa-solid fa-warehouse me-1' />
                                                                        Indoor
                                                                    </span>
                                                                )}
                                                                {test.speed && (
                                                                    <span class='badge bg-primary'>
                                                                        <i class='fa-solid fa-gauge-high me-1' />
                                                                        {test.speed} {test.speedUnit || 'fps'}
                                                                    </span>
                                                                )}
                                                                {test.speedMin && test.speedMax && (
                                                                    <>
                                                                        <span class='badge bg-secondary'>
                                                                            {test.speedMin}-{test.speedMax}
                                                                        </span>
                                                                        <span class='badge bg-warning text-dark'>
                                                                            ES: {test.speedMax - test.speedMin}
                                                                        </span>
                                                                    </>
                                                                )}
                                                                {test.speedStdDev && (
                                                                    <span class='badge bg-info text-dark'>
                                                                        SD: {test.speedStdDev}
                                                                    </span>
                                                                )}
                                                                {test.accuracy && (
                                                                    <span class='badge bg-success'>
                                                                        <i class='fa-solid fa-bullseye me-1' />
                                                                        {test.accuracy} {test.accuracyUnit || 'MOA'}
                                                                    </span>
                                                                )}
                                                                {test.distance && (
                                                                    <span class='badge bg-info'>
                                                                        <i class='fa-solid fa-ruler me-1' />
                                                                        {test.distance} {test.distanceUnit || 'm'}
                                                                    </span>
                                                                )}
                                                            </div>

                                                            {/* Weather Data */}
                                                            {test.weather && (
                                                                <div class='mt-2 p-2 bg-light rounded small'>
                                                                    <i class='fa-solid fa-cloud me-1 text-info' />
                                                                    <strong>Weather:</strong>
                                                                    {test.weather.temperature !== undefined && (
                                                                        <span class='ms-2'>
                                                                            <i class='fa-solid fa-temperature-half me-1' />
                                                                            {test.weather.temperature}°C
                                                                        </span>
                                                                    )}
                                                                    {test.weather.humidity !== undefined && (
                                                                        <span class='ms-2'>
                                                                            <i class='fa-solid fa-droplet me-1' />
                                                                            {test.weather.humidity}%
                                                                        </span>
                                                                    )}
                                                                    {test.weather.windSpeed !== undefined && (
                                                                        <span class='ms-2'>
                                                                            <i class='fa-solid fa-wind me-1' />
                                                                            {test.weather.windSpeed} m/s
                                                                            {test.weather.windDirection !== undefined && (
                                                                                <span> ({test.weather.windDirection}°)</span>
                                                                            )}
                                                                        </span>
                                                                    )}
                                                                    {test.weather.pressure !== undefined && (
                                                                        <span class='ms-2'>
                                                                            <i class='fa-solid fa-gauge me-1' />
                                                                            {test.weather.pressure} hPa
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            )}

                                                            {/* Test Notes */}
                                                            {test.notes && (
                                                                <div class='mt-2 small text-muted'>
                                                                    <i class='fa-solid fa-note-sticky me-1' />
                                                                    {test.notes}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* Rating */}
                        <div class='px-3 mb-4'>
                            <div class='card'>
                                <div class='card-header'>
                                    <i class='fa-solid fa-star me-2' />
                                    Rating
                                </div>
                                <div class='card-body'>
                                    <div class='d-flex align-items-center'>
                                        {[1, 2, 3, 4, 5].map(star => (
                                            <i
                                                key={star}
                                                class={`fa-${star <= (lotTesting.rating || 0) ? 'solid' : 'regular'} fa-star text-warning me-1`}
                                                style='font-size: 1.5rem;'
                                            />
                                        ))}
                                        {lotTesting.rating ? (
                                            <span class='ms-2 text-muted'>({lotTesting.rating}/5)</span>
                                        ) : (
                                            <span class='ms-2 text-muted'>Not rated yet</span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Comments */}
                        <div class='px-3 mb-4'>
                            <div class='card'>
                                <div class='card-header'>
                                    <i class='fa-solid fa-comments me-2' />
                                    Comments
                                </div>
                                <div class='card-body p-0'>
                                    <Comments
                                        stores={this.props.stores}
                                        type='lotTesting'
                                        objectId={lotTesting.id}
                                        comments={lotTesting.comments || []}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Metadata */}
                        <div class='px-3 mb-4'>
                            <div class='small text-muted'>
                                {lotTesting.createdDate && (
                                    <div>
                                        <i class='fa-solid fa-calendar-plus me-1' />
                                        Created: {localUtil.formatDate(lotTesting.createdDate, true)}
                                    </div>
                                )}
                                {lotTesting.updatedDate && (
                                    <div>
                                        <i class='fa-solid fa-calendar-check me-1' />
                                        Updated: {localUtil.formatDate(lotTesting.updatedDate, true)}
                                    </div>
                                )}
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}

export default LotTestingViewOnly;
